/* Hero (homepage) – automatické prolínání více fotek osoby
 * + synchronní prolínání siluety města v pozadí (data-hero-silueta).
 * Aktivuje se jen na .hero-foto[data-hero-foto] s 2+ obrázky.
 * Interval z data-interval (ms). Respektuje prefers-reduced-motion.
 * Základní opacity + transition jsou inline v šabloně, takže bez JS
 * (nebo při jediné fotce) zůstane staticky vidět první fotka a její silueta. */
(function () {
	function initHeroFoto(box) {
		var imgs = box.querySelectorAll('.hero-foto-img');
		if (imgs.length < 2) return;

		if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

		var interval = parseInt(box.getAttribute('data-interval'), 10);
		if (!interval || interval < 1000) interval = 5000;

		var sekce = box.closest ? box.closest('.page-hero') : null;
		var siluety = sekce ? sekce.querySelectorAll('[data-hero-silueta]') : [];
		var jmenovky = box.querySelectorAll('[data-hero-jmenovka]');

		var current = 0;
		setInterval(function () {
			var next = (current + 1) % imgs.length;
			imgs[current].style.opacity = '0';
			imgs[next].style.opacity = '1';
			// Silueta se stejným indexem se ukáže, ostatní zhasnou.
			// Osoba bez vrstvy => všechny zhasnou (nemá siluetu).
			for (var j = 0; j < siluety.length; j++) {
				siluety[j].style.opacity =
					siluety[j].getAttribute('data-hero-silueta') === String(next) ? '.25' : '0';
			}
			// Jmenovka jede stejně – osoba bez jmenovky nemá vrstvu, všechny zhasnou.
			for (var k = 0; k < jmenovky.length; k++) {
				jmenovky[k].style.opacity =
					jmenovky[k].getAttribute('data-hero-jmenovka') === String(next) ? '1' : '0';
			}
			current = next;
		}, interval);
	}

	function init() {
		var boxes = document.querySelectorAll('.hero-foto[data-hero-foto]');
		for (var i = 0; i < boxes.length; i++) initHeroFoto(boxes[i]);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
